import { Button, Icon } from '@kim/ui';
import React from 'react';
import './index.less';
import intl from '@/internationalzation/intl';
import { ButtonProps } from '@kim/ui/src/components/Button/Button';
interface ICreateTaskButtonProps extends ButtonProps {
  onClick: () => void;
  iconSize?: number;
  className?: string;
}

export const CreateTaskButton = (props: ICreateTaskButtonProps) => {
  const { onClick, iconSize = 18, className = '', ...rest } = props;
  return (
    <Button
      type="main"
      size="large"
      className={`kim-ai-mario-create-task-button ${className}`}
      {...rest}
      onClick={onClick}
    >
      <Icon
        name="icon-global_03_action_tianjiazhong_line"
        size={iconSize}
        className="add-btn-icon"
      />
      {intl.t('mario.newTask')}
    </Button>
  );
};
